import React from 'react';
import PropTypes from 'prop-types';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import { FDStack } from '@facet-wealth/design';
import InvestmentApproachSection, { sectionMetaOverrideSet } from './section';

const InvestmentApproachSections = ({ collection }) => {
  return (
    <FDStack direction={'row'} spacing={4} justifyContent={'center'} wrap>
      <MetaCollectionRenderer collection={collection} layout={InvestmentApproachSection} metaOverrideSet={sectionMetaOverrideSet} />
    </FDStack>
  );
};

InvestmentApproachSections.propTypes = {
  collection: PropTypes.object.isRequired,
};

InvestmentApproachSections.defaultProps = {};

export default InvestmentApproachSections;
